import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProfileTypeIdentifier } from '@enum/profile-type-identifier';
import { UserService } from '@service/user/user.service';

@Component({
  selector: 'profile-selector',
  templateUrl: './profile-selector.component.html',
  styleUrls: ['./profile-selector.component.scss'],
})
export class ProfileSelectorComponent {
  public ProfileTypeIdentifier = ProfileTypeIdentifier;
  @Input()
  public form: FormGroup;

  constructor(public UserService: UserService) {}

  showPrivate() {
    const companyProfile = this.UserService.getCompanyProfile();

    // allow private profile only if the company profile is not published yet or if it is a simple company profile
    // premium company profiles should not be able to publish with private profiles
    if (!companyProfile || (companyProfile && companyProfile.type == 'CARPENTER')) {
      return true;
    }
    return false;
  }
}
